import { module } from 'angular';
import component from './collabora-online.component';

export default module('app.collabora-online', [])
	.component('collaboraOnline', component)
	.name;
